<template>
  <tr>
    <td v-if="payer">
      <a
        :href="payerLink"
        v-text="payer.attributes.full_name"
      />
    </td>
    <td>
      <strong v-text="'Amount: '" />
      {{ payment.attributes.amount }}
      <br>
      <strong v-text="'Type: '" />
      Dues
      <br>
      <strong v-text="'Created: '" />
      {{ paymentCreatedAt }}
      <br>
      <strong v-text="'Invoice: '" />
      <a
        :href="payment.attributes.invoice_pdf"
        class="icon"
        target="_blank"
        rel="noopener noreferrer"
        v-text="'Download'"
      />
      <br>
    </td>
    <td v-text="refund.attributes.reason" />
    <td v-text="refundedAt" />
    <td v-text="refund.attributes.status" />
  </tr>
</template>

<script type="text/babel">
export default {
  name: 'RefundRow',
  props: {
    refund: {
      type: Object,
      required: true,
    },
  },
  computed: {
    payment() {
      return this.refund.payment
    },
    payer() {
      return this.payment.payer
    },
    payerLink() {
      return this.payer ? this.$urlGenerator.active(`members/${this.payer.uuid}`) : ''
    },
    paymentCreatedAt() {
      return this.$date.toMomentDateFormat(this.payment.attributes.created_at * 1000)
    },
    refundedAt() {
      return this.$date.toMomentDateFormat(this.refund.attributes.created_at)
    },
  },
  methods: {
    refreshPayment() {
      this.$emit('refreshPayments')
    },
  },
}
</script>
